'use strict';

const cache = {
    $map: $('#map'),
    $lat: $('#lat'),
    $long: $('#long'),
    $marker: null,
    $cityCircle: null,
    $crossIcon: $('.icon__cross-circle-map-locator').html(),
    $loggedInOutage: $('.js-logged-in-outage'),
    $loggedOutOutage: $('.js-logged-out-outage')
};

/**
 * Initialize google maps
 */
function initMap() {
    let userlat = +cache.$map.data('userlat');
    let userlng = +cache.$map.data('userlng');
    // center of US
    let defaultLat = 38;
    let defaultLng = -97;
    let initialZoom = userlat ? 18 : 4;

    let userLatLng = {
        lat: userlat || defaultLat,
        lng: userlng || defaultLng
    };
    const map = new window.google.maps.Map(document.getElementById('map'), {
        center: userLatLng,
        zoom: initialZoom,
        clickableIcons: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
    });

    const template = cache.$crossIcon;
    var svg = template.replace('{{ color }}', '#888');
    var blob = new Blob([svg], { type: 'image/svg+xml' });
    var blobUrl = URL.createObjectURL(blob);

    var image = {
        url: blobUrl,
        anchor: new window.google.maps.Point(13, 13)
    };
    // this is to check wether to render template icon or notmal location pointer icon on map
    const isUserLoggedIn = $('#isUserLoggedIn').val();
    if (isUserLoggedIn) {
        cache.$marker = new window.google.maps.Marker({
            position: userLatLng,
            map,
            icon: image,
            draggable: false
        });
    }

    map.addListener('click', (e) => {
        cache.$lat.val(e.latLng.lat());
        cache.$long.val(e.latLng.lng());
    });
}


module.exports = {
    initEvents: function () {
        $(document).ready(function () {
            if ('google' in window) {
                initMap();
            }
        });
        var gtmPushObj = {};
        if (cache.$loggedInOutage.length) {
            gtmPushObj.step = 'outage map load';
        } else if (cache.$loggedOutOutage.length) {
            gtmPushObj.step = 'outage checker load';
        }
        $('body').trigger('gtm:mp:outageToolPage', gtmPushObj);
    }
};
